import React, { useState } from "react";
import { TableCell, TableRow, Tooltip, IconButton,Checkbox } from "@material-ui/core"
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import { permissionCheckFnforCamo } from "../../../utils";

const TemplatesList = ({ item, onViewFn, onDeleteFn, onEditFn,toggleBulkOps,bulk }) => {
    const [lessMore, setLessMore] = useState({});

    const toggleLessMore = (lessMr) => {
        setLessMore({
            ...lessMore,
            [lessMr]: !lessMore[lessMr]
        });
    }
    let timezone = moment().format()
    const timestamp = Math.floor(Date.now() / 1000);
    const Template_url = `audit/camo/camotemplate/?object_id=${item.id}&action=0,1&timezone=${timezone}&timestamp=${timestamp}`
    const lessMoreFn = (name, lessMr) => {
        return <>
            {name && name?.length > 35 ? (
                <>
                    {lessMore[lessMr] ?
                        (<> {name} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..less </span> </>)
                        :
                        (<>{name?.substring(0, 35)} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..more </span> </>)
                    }
                </>
            ) : name || '--'
            }
        </>
    }
    return (
        <>
            <TableRow >
                <TableCell>
                    <Checkbox
                        color="primary"
                        size="small"
                        checked={bulk?.ids?.find(items => items?.id === item?.id) ? true : false}
                        onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                    />
                </TableCell>
                <TableCell >
                    {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "R" }) ? <Tooltip title="View" placement='top'>
                        <IconButton style={{ padding: 'unset' }} color='primary' onClick={onViewFn} >
                            <VisibilityIcon />
                        </IconButton>
                    </Tooltip> : null}
                    {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) ? <Tooltip title="Edit" placement='top'>
                        <IconButton style={{ padding: 'unset' }} color='primary' onClick={onEditFn} >
                            <CreateOutlinedIcon />
                        </IconButton>
                    </Tooltip> : null}
                    {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) ? <Tooltip title="Delete" placement='top' >
                        <IconButton style={{ padding: 'unset' }} color='secondary' onClick={onDeleteFn}>
                            <DeleteOutlinedIcon />
                        </IconButton>
                    </Tooltip> : null}
                    <RevisionHistory buttonType={true} url={Template_url} />
                </TableCell>
                <TableCell>{item?.engine_family?.name || "--"}</TableCell>
                <TableCell>{lessMoreFn(item?.remarks, "remarks")}</TableCell>
                <TableCell>{item?.section_id?.name || "--"}</TableCell>
                <TableCell>
                    <Tooltip title={item?.file_path? "Click to download" : ''}>
                        <span style={{ cursor:item?.file_path ? 'pointer' : '', color: '#bd10e0' }} onClick={(e) => item?.file_path ? window.open(item.file_path, "_self") : e.preventDefault()}>{item?.file_name ? item.file_name.replace(".xlsx", "") : "--"}</span>
                    </Tooltip>
                </TableCell>
                <TableCell>{item?.active ? "YES" : "No" || "--"}</TableCell>
                <TableCell>{item?.created_by?.name || "--"}</TableCell>
                <TableCell>{item?.updated_by?.name || "--"}</TableCell>
            </TableRow>
        </>
    )
}

export default withRouter(TemplatesList)